import Storage from "good-storage";
import { getOrgByDomain } from "@/api/common.js";

export function setOrgInfo(callback) {
  let orgInfo = Storage.session.get("ORG_INFO");
  if (orgInfo) {
    callback(orgInfo);
  } else {
    getOrgByDomain({})
      .then(r => {
        callback(r);
        Storage.session.set("ORG_INFO", r);
      })
      .catch(() => {});
  }
}
